import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import * as _ from 'lodash-es';

import type { RootState } from '../../RootState';

import { initialState } from './state';

const kbarSlice = createSlice({
  name: 'kbar',
  initialState,
  reducers: {
    setSearchInputFocused: (state, action: PayloadAction<boolean>) => {
      state.searchInputFocused = action.payload;
    },
    setOpenSelectAppModal: (state, action: PayloadAction<boolean>) => {
      state.openSelectAppModal = action.payload;
    },
    setShouldUpdateApps: (state, action: PayloadAction<boolean>) => {
      state.shouldUpdateApps = action.payload;
    },
    rehydrate: (state) => {
      _.merge(state, initialState);
    },
  },
});

export const kbarToolkit = Object.freeze({
  initialState,
  actions: kbarSlice.actions,
  selectors: {
    state: (state: RootState) => state.kbar,
    rehydrate: (state: RootState) => state.kbar,
    searchInputFocused: (state: RootState) => state.kbar.searchInputFocused,
    openSelectAppModal: (state: RootState) => state.kbar.openSelectAppModal,
    shouldUpdateApps: (state: RootState) => state.kbar.shouldUpdateApps,
  },
});

export const kbarReducer = kbarSlice.reducer;
